import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
// import injectTapEventPlugin from 'react-tap-event-plugin';
import { createStore } from './redux'
import Router from './controllers/app/Router';
import { unregister } from './registerServiceWorker';
import bugsnag from 'bugsnag';
// import mixpanel from 'mixpanel';

import 'react-select/dist/react-select.css';
import 'react-activity-indicator/src/activityindicator.css'
import './controllers/app/App.css';
import './index.css';

bugsnag.register("577ca2d199e7089be02501a1d89a994c");

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function(searchString, position){
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

if (navigator.appName === 'Microsoft Internet Explorer' ||  !!(navigator.userAgent.match(/Trident/) || navigator.userAgent.match(/rv:11/))){
  //TODO fix for IE. Current app logic in retrieving data is inefficient. Object.keys used for checking bool variables... cause errors on IE.

  Object.keys = (function() {
    'use strict';
    var hasOwnProperty = Object.prototype.hasOwnProperty,
      hasDontEnumBug = !({ toString: null }).propertyIsEnumerable('toString'),
      dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
      ],
      dontEnumsLength = dontEnums.length;

    return function(obj) {
      if (typeof obj !== 'function' && (typeof obj !== 'object' || obj === null)) {
        return [];
        console.warn('Object.keys called on non-object');
      }

      var result = [], prop, i;

      for (prop in obj) {
        if (hasOwnProperty.call(obj, prop)) {
          result.push(prop);
        }
      }

      if (hasDontEnumBug) {
        for (i = 0; i < dontEnumsLength; i++) {
          if (hasOwnProperty.call(obj, dontEnums[i])) {
            result.push(dontEnums[i]);
          }
        }
      }
      return result;
    };
  }());
}

// Needed for onClick
// injectTapEventPlugin();

const store = createStore();

ReactDOM.render((
  <MuiThemeProvider>
    <Provider store={store}>
      <Router />
    </Provider>
  </MuiThemeProvider>
), document.getElementById('root'));

unregister();
